<template>
	<div class="box login-box">
		<!-- 登录 -->
		<div class="login" :class="{ show: showType == 'login' }">
			<h3>会员登录</h3>
			<a title="扫码登录" class="login_a" @click="showDiv(3)">
				<img  style="width:40px;height:40px"  class="codeimg"  src="images/wx.png" width="60" height="60" />
			</a>
			<span class="el-icon-close" @click="close"></span>
			<el-form :model="form">
				<el-form-item :class="{ 'is-error': formMsg.phoneMsg != '' }">
					<el-input v-model="form.phone" type="number" placeholder="请输入注册手机号码"></el-input>
					<div class="login-err" :class="{ 'login-err-active': formMsg.phoneMsg != '' }">
						{{ formMsg.phoneMsg }}
					</div>
				</el-form-item>
				<el-form-item :class="{ 'is-error': formMsg.passwordMsg != '' }">
					<el-input v-model="form.password" placeholder="请输入注册密码" show-password></el-input>
					<div class="login-err" :class="{ 'login-err-active': formMsg.passwordMsg != '' }">
						{{ formMsg.passwordMsg }}
					</div>
				</el-form-item>
				<el-form-item class="login-code" :class="{ 'is-error': formMsg.codeMsg != '' }">
					<el-input v-model="form.code" placeholder="请输入验证码" style="width: 200px !important;"></el-input>
					<div class="login-err" :class="{ 'login-err-active': formMsg.codeMsg != '' }">
						{{ formMsg.codeMsg }}
					</div>
					<el-button @click="refreshCode" style="width: px;">
						<img :src="base64">
					</el-button>
					<a @click="showDiv(5)">忘记密码？</a>
				</el-form-item>

				<el-button type="primary" class="btn-login" @click="loginSub" @keyup.13.native="loginSub">立即登录
				</el-button>
				<p>
					<a @click="showDiv(6)" id="qqlogin">
						<img style="width:40px ;height:40px" src="images/qq.png" /> 
					</a>
					<a class="regis_a" @click="showDiv(2)">手机注册</a>
				</p>
			</el-form>
		</div>

		<!-- 注册 -->
		<div class="regis" :class="{ show: showType == 'regis' }">
			<h3>会员注册</h3>
			<a title="扫码登录" class="login_c" @click="showDiv(3)">
				<img  style="width:40px;height:40px"   src="images/wx.png" width="60" height="60" />
			</a>
			<span class="el-icon-close" @click="close"></span>
			<el-form  ref="rulesfrom"   :model="form"    :rules="formRule">
				<el-form-item   prop="phone"    :class="{ 'is-error': formMsg.phoneMsg != '' }">
					<el-input type="number" v-model="form.phone" placeholder="请输入手机号码"></el-input>
					<div class="login-err" :class="{ 'login-err-active': formMsg.phoneMsg != '' }">
						{{ formMsg.phoneMsg }}
					</div>
				</el-form-item  >
				<el-form-item  prop="code" class="login-code" :class="{ 'is-error': formMsg.codeMsg != '' }">
					<el-input v-model="form.code" placeholder="请输入验证码" maxlength="6"></el-input>
					<div class="login-err" :class="{ 'login-err-active': formMsg.codeMsg != '' }">
						{{ formMsg.codeMsg }}
					</div>
					<el-button @click="getCode(1)" :disabled='clicks'>{{ btnText }}</el-button>
				</el-form-item>
				<el-form-item   prop="password"     :class="{ 'is-error': formMsg.passwordMsg != '' }">
					<el-input type="password" v-model="form.password" placeholder="请输入密码" autocomplete="off"
						show-password></el-input>
					<div class="login-err" :class="{ 'login-err-active': formMsg.passwordMsg != '' }">
						{{ formMsg.passwordMsg }}
					</div>
				</el-form-item>
				<el-form-item   :class="{ 'is-error': formMsg.checkPasswordMsg != '' }">
					<el-input type="password" v-model="form.checkPasswords"   placeholder="请再次输入密码" autocomplete="off"
						show-password></el-input>
					<div class="login-err" :class="{ 'login-err-active': formMsg.checkPasswordMsg != '' }">
						{{ formMsg.checkPasswordMsg }}
					</div>
				</el-form-item>

				<el-button type="primary" class="btn-login" @click="regisSub" @keyup.13.native="regisSub">立即注册
				</el-button>
				<p>
					<a @click="showDiv(6)">
						<img style="width:40px;height:40px"  src="images/qq.png" /> 
						
					</a>
					<a class="regis_a" @click="showDiv(1)">会员登录</a>
				</p>
			</el-form>
		</div>

		<!-- 扫码登录 -->
		<!-- <div class="login-wx" :class="{ show: showType == 'code' }">
		
			<a title="会员登录" class="login_a" @click="showDiv(1)">
				<img src="images/login_2.png" width="60" height="60" />
			</a>
			<span class="el-icon-close" @click="close"></span>
			<dl>

				<div id="iframe-container"   style="height:200px">
       <iframe :src="wxbinds" scrolling="auto"  frameborder="0" id="iframe"></iframe>
  				</div>	
				<dt id="wxImg" ref="wxlogin"></dt>
				<dd>使用微信扫描二维码登录</dd>
				<p  class="shuxin" @click="getWxScan" >
					<img  src="images/login_4.png" />二维码加载失败？点击刷新
				</p>
				<a class="regis_a wxsaom" @click="showDiv(2)">手机号注册</a>
			</dl>
		</div> -->

		<!-- 绑定 -->
		<div class="login-bind" :class="{ show: showType == 'bind' }">
			<h3>绑定手机</h3>
		
			<span class="el-icon-close" @click="close"></span>
			<el-form  v-model="form" >
				<el-form-item :class="{ 'is-error': formMsg.phoneMsg != '' }">
					
					<el-input v-model="form.phone" placeholder="请输入手机号码"></el-input>
					<div class="login-err" :class="{ 'login-err-active': formMsg.phoneMsg != '' }">
						{{ formMsg.phoneMsg }}
					</div>
				</el-form-item>
				<el-form-item class="login-code" :class="{ 'is-error': formMsg.codeMsg != '' }">
					<el-input v-model="form.codes" placeholder="请输入验证码" maxlength="6"></el-input>
					<div class="login-err" :class="{ 'login-err-active': formMsg.codeMsg != '' }">
						{{ formMsg.codeMsg }}
					</div>
					<el-button @click="getCode(1)" :disabled="codeText !== '获取验证码'">{{ codeText }}</el-button>
				</el-form-item>
				<el-form-item :class="{ 'is-error': formMsg.passwordMsg != '' }">
					<el-input v-model="form.password" placeholder="请输入密码" show-password></el-input>
					<div class="login-err" :class="{ 'login-err-active': formMsg.passwordMsg != '' }">
						{{ formMsg.passwordMsg }}
					</div>
				</el-form-item>
				<el-form-item :class="{ 'is-error': formMsg.checkPasswordMsg != '' }">
					<el-input v-model="form.checkPassword" placeholder="请再次输入密码" show-password></el-input>
					<div class="login-err" :class="{ 'login-err-active': formMsg.checkPasswordMsg != '' }">
						{{ formMsg.checkPasswordMsg }}
					</div>
				</el-form-item>

				<el-button type="primary" class="btn-login" @click="bindSub" @keyup.13.native="bindSub">立即绑定</el-button>
			</el-form>
		</div>

		<!-- 忘记密码 -->
		<div class="login-pass" :class="{ show: showType == 'pass' }">
			<h3>忘记密码</h3>
		
			<span class="el-icon-close" @click="close"></span>
			<el-form>
				<el-form-item :class="{ 'is-error': formMsg.phoneMsg != '' }">
					<el-input v-model="form.phone" placeholder="请输入手机号码"></el-input>
				
					<div class="login-err" :class="{ 'login-err-active': formMsg.phoneMsg != '' }">
						{{ formMsg.phoneMsg }}
					</div>
				</el-form-item>
				<el-form-item class="login-code" :class="{ 'is-error': formMsg.codeMsg != '' }">
					<el-input v-model="form.code" placeholder="请输入验证码" maxlength="6"></el-input>
					<div class="login-err" :class="{ 'login-err-active': formMsg.codeMsg != '' }">
						{{ formMsg.codeMsg }}
					</div>
					<el-button @click="getCode(2)" :disabled='clicks'   >{{ btnText }}</el-button>
				<!-- :disabled="codeText !== '获取验证码'" -->
				</el-form-item>
				<el-form-item :class="{ 'is-error': formMsg.passwordMsg != '' }">
					<el-input v-model="form.password" placeholder="请输入密码" show-password></el-input>
					<div class="login-err" :class="{ 'login-err-active': formMsg.passwordMsg != '' }">
						{{ formMsg.passwordMsg }}
					</div>
				</el-form-item>
				<el-form-item :class="{ 'is-error': formMsg.checkPasswordMsg != '' }">
					<el-input v-model="form.checkPassword" placeholder="请再次输入密码" show-password></el-input>
					<div class="login-err" :class="{ 'login-err-active': formMsg.checkPasswordMsg != '' }">
						{{ formMsg.checkPasswordMsg }}
					</div>
				</el-form-item>

				<el-button type="primary" class="btn-login" @click="passSub" @keyup.13.native="passSub">确定</el-button>
					<a class="regis_a regisn" @click="showDiv(1)">会员登录</a>
			</el-form>
		</div>

		<!-- qq登录 -->
		<div class="login-frame" :class="{ show: showType == 'frame' }">
		<!-- <iframe frameborder="0" style="width:100%; height:100%; min-height:420px" name="qq"></iframe> -->
		</div>
	</div>
</template>

<script>
	import Code from "@/components/Code.vue";
import router from '../router';
	export default {
		props: ["loginType", "bindId"],
		inject: ["reload"],
		data() {
					function  phoone(rule,value,callback){
					let userinfo = JSON.parse(localStorage.getItem('userInfo'))
					let reg =/^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/	
						 //console.log(value)
						 if(value === '' || value===undefined || value == null){
							 callback(new Error("电话不能为空"))
						 }
						 else{
							 if(!reg.test(value) ){
								 callback(new Error("电话格式错误错误"))
							 }else{
								 callback()
							 }
						 }
					}
					let that = this
					// 二次密码验证
					function checkPasswords(rule,value,callback){
						//console.log(value)
						if(value === that.form.password){
							callback()
						}
						else{		
								callback(new Error("重复密码不一致，请重新输入"))
						}	
					
					}	




			return {
				showType: this.loginType,
		

				bind_id: this.bindId,
				form: {
					phone: "",
					password: "",
					checkPassword: "",
					checkPasswords:'',
					code: "",
					codes:'',
				},
			time:'',
			times:"",
				clicks:false,
				formMsg: {
					phoneMsg: "",
					passwordMsg: "",
					checkPasswordMsg: "",
					codeMsg: "",
				},
				bindUrl:'',
				btnText:'获取验证码',
				flag: true, //该值变化，就会触发刷新
				imgCode: "", //
				codeText: "获取验证码",
				bindType: "",
				base64: '',
				wxbinds:'',
				key: '',
				formRule: {
				phone:[	{validator:phoone,trigger:'none'}],	
				checkPasswordes:[
												{validator:checkPasswords,trigger:'none'},
												{message:"密码不能为空111",trigger:'none'},
												],
				
				password:[{required:true,message:'密码不能为空',trigger:'none'},
										{min:6, max:12, message:'密码格式错误，密码为6-12位',trigger:'none'}],
				code:[{required:true,message:"验证码不能为空",trigger:'none'},
							{min:6,max:6,message:"验证码格式错误,6位数验证码",trigger:"none" }],
				

				},	
			};
		},
		methods: {
			// 显示切换
			showDiv(index) {
				if(index == 1){
					this.showType = "login"; //登录
					this.resetForm();
				}else if(index == 2){
					this.showType = "regis"; //注册
					this.resetForm();
				}else if(index == 3){
					this.showType = "code";
					this.getWxScan();
				}else if(index == 4){
					this.showType = "bind"; 
				}else if(index == 5){
					this.showType = "pass"; //忘记密码
					this.resetForm();
				}else if(index == 6){
					this.showType = "frame"; //qqframe
					this.useqqlogin();
				}
				// this.$emit("listenLogin", this.showType);
			},
			//登录提交
			loginSub() {
				if (this.form.phone == "") {
					this.formMsg.phoneMsg = "请输入手机号码";
				} else if (!this.checkMobile(this.form.phone)) {
					this.formMsg.phoneMsg = "请输入正确的手机号码";
				} else if (this.form.password == "") {
					this.formMsg.passwordMsg = "请输入密码";
				} else if (this.form.code == "") {
					this.formMsg.codeMsg = "请输入验证码";
				} else {
					let data = {
						mobile: this.form.phone,
						password: this.form.password,
						captcha: this.form.code,
						captcha_key: this.key,
						// type:2,
					}
					this.$api.login(data).then(res => {
						//console.log(res)
						if (res.code == 400) {
							this.$message.error(res.msg)
							this.refreshCode()
							this.form.code = ''
						} else if (res.code == 200) {
							//console.log(res)
							localStorage.setItem('UserToken', res.data.token)
							localStorage.setItem('userInfo', JSON.stringify(res.data.userInfo))
							localStorage.setItem('userId', res.data.user_id)
							this.$message.success('登陆成功')
							this.$router.go(0);
							this.$emit('listenLogin','login')
						}
					})
				}

				return
				if (this.form.phone == "") {
					this.formMsg.phoneMsg = "请输入手机号码";
				} else {
					if (!this.checkMobile(this.form.phone)) {
						this.formMsg.phoneMsg = "请输入正确的手机号码";
					} else {
						this.formMsg.phoneMsg = "";
						if (this.form.password == "") {
							this.formMsg.passwordMsg = "请输入密码";
						} else {
							this.formMsg.passwordMsg = "";
							if (this.form.code == "") {
								this.formMsg.codeMsg = "请输入验证码";
							} else {
								if (this.form.code != this.imgCode) {
									this.formMsg.codeMsg = "验证码错误";
									this.refreshCode();
								} else {
									this.formMsg.codeMsg = "";
									var param = {
										mobile: this.form.phone,
										password: this.form.password,
									};
									this.$post("phoneGo", param).then((res) => {
										// //console.log(res);
										if (res.code == 200) {
											this.storageUserInfo(
												res.data.token,
												res.data.userInfo.nickname,
												res.data.userInfo.image,
												res.data.userInfo.is_vip

											);
											this.succeMessage(res.msg);
										} else if (res.code == 2) {
											this.formMsg.phoneMsg = res.msg;
										} else if (res.code == 3) {
											this.formMsg.passwordMsg = res.msg;
										}
									});
								}
							}
						}
					}
				}
			},
			// 刷新图形验证码
			refreshCode() {
				this.$api.captcha().then(res => {
					//console.log(res)
					this.base64 = res.data.base64
					this.key = res.data.key
				})
			},
			// 获取图形验证码
			getMakedCode(code) {
				this.imgCode = code;
			},
			// 注册提交
		regisSub() {
			let that = this
					this.$refs['rulesfrom'].validate (( ispass)=>{
						if(ispass){
							
							if(that.form.checkPasswords ===  that.form.password){
										let user = {
						mobile:this.form.phone ,
						password: this.form.password,
						code:this.form.code ,	
						}
					  this.$api.register(user).then((res)=>{
						//console.log(res)	 	
					 	 if(res.data.msg === '已经注册!'){
									that.$message.error("该电话已注册，请勿重复注册")
									}
					 	 else{
									that.$message.success("注册成功")
									this.form.phone = ''
									 that.form.code =''
									 that.form.password = ''
									 that.form.checkPasswords =''
							}
					 
					 })		
							}
							else{
								that.$message.error("两次密码不一致请重新输入")
				
							}

					}else{
							that.$message.error("格式错误请重新输入")
							
					}	
					
					})
				
					
					
					
					
				


				// var that = this;
				// if (this.form.phone == "") {
				// 	this.formMsg.phoneMsg = "请输入手机号码";
				// } else {
				// 	if (!this.checkMobile(this.form.phone)) {
				// 		this.formMsg.phoneMsg = "请输入正确的手机号码";
				// 	} else {
				// 		this.formMsg.phoneMsg = "";
				// 		if (this.form.code == "") {
				// 			this.formMsg.codeMsg = "请输入验证码";
				// 		} else {
				// 			this.formMsg.codeMsg = "";
				// 			if (this.form.password == "") {
				// 				this.formMsg.passwordMsg = "请输入密码";
				// 			} else {
				// 				if (this.form.password.length < 6) {
				// 					this.formMsg.passwordMsg = "密码不能少于6位";
				// 				} else if (!this.checkPass(this.form.password)) {
				// 					this.formMsg.passwordMsg = "密码必须是数字或者字母";
				// 				} else {
				// 					this.formMsg.passwordMsg = "";
				// 					if (this.form.checkPassword == "") {
				// 						this.formMsg.checkPasswordMsg = "请再次输入密码";
				// 					} else {
				// 						if (this.form.checkPassword !== this.form.password) {
				// 							this.formMsg.checkPasswordMsg = "两次输入密码不一致";
				// 						} else {
				// 							this.formMsg.checkPasswordMsg = "";
				// 							var param = {
				// 								mobile: this.form.phone,
				// 								password: this.form.password,
				// 								notpassword: this.form.checkPassword,
				// 								captcha: this.form.code,
				// 							};
				// 							this.$post("phoneReady", param).then((res) => {
				// 								//console.log(res);
				// 								if (res.code == 101) {
				// 									this.formMsg.phoneMsg = res.msg;
				// 								} else if (res.code == 100010) {
				// 									this.formMsg.codeMsg = res.msg;
				// 								} else if (res.code == 200) {
				// 									this.storageUserInfo(
				// 										res.data.token,
				// 										res.data.nickname,
				// 										res.data.image,
				// 										0
				// 									);
				// 									this.succeMessage(res.msg);
				// 								}
				// 							});
				// 						}
				// 					}
				// 				}
				// 			}
				// 		}
				// 	}
				// }
			},
			// 忘记密码提交
			passSub() {
				if (this.form.phone == "") {
					this.formMsg.phoneMsg = "请输入手机号码";
				} else {
					if (!this.checkMobile(this.form.phone)) {
						this.formMsg.phoneMsg = "请输入正确的手机号码";
					} else {
						this.formMsg.phoneMsg = "";
						if (this.form.code == "") {
							this.formMsg.codeMsg = "请输入验证码";
						} else {
							this.formMsg.codeMsg = "";
							if (this.form.password == "") {
								this.formMsg.passwordMsg = "请输入密码";
							} else {
								if (this.form.password.length < 6) {
									this.formMsg.passwordMsg = "密码不能少于6位";
								} else if (!this.checkPass(this.form.password)) {
									this.formMsg.passwordMsg = "密码必须是数字或者字母";
								} else {
									this.formMsg.passwordMsg = "";
									if (this.form.checkPassword == "") {
										this.formMsg.checkPasswordMsg = "请再次输入密码";
									} else {
										if (this.form.checkPassword !== this.form.password) {
											this.formMsg.checkPasswordMsg = "两次输入密码不一致";
										} else {
											this.formMsg.checkPasswordMsg = "";
											var param = {
												mobile: this.form.phone,
												password: this.form.password,
												notpassword: this.form.checkPassword,
												code: this.form.code,
											};
										this.$api.userForgoPassword(param).then((res)=>{
												//console.log(res)
													if (res.code == 0) {
													this.formMsg.phoneMsg = res.msg;
												} else if (res.code == 100010) {
													this.formMsg.codeMsg = res.msg;
												} else if (res.code == 200) {
													this.succeMessage(res.msg);
												}
										})
										
										
										
										
									
										}
									}
								}
							}
						}
					}
				}
			},
			// 绑定提交
			bindSub() {
				if (this.form.phone == "") {
					this.formMsg.phoneMsg = "请输入手机号码";
				} else {
					if (!this.checkMobile(this.form.phone)) {
						this.formMsg.phoneMsg = "请输入正确的手机号码";
					} else {
						this.formMsg.phoneMsg = "";
						if (this.form.codes == "") {
							this.formMsg.codeMsg = "请输入验证码";
						} else {
							this.formMsg.codeMsg = "";
							if (this.form.password == "") {
								this.formMsg.passwordMsg = "请输入密码";
							} else {
								if (this.form.password.length < 6) {
									this.formMsg.passwordMsg = "密码不能少于6位";
								} else if (!this.checkPass(this.form.password)) {
									this.formMsg.passwordMsg = "密码必须是数字或者字母";
								} else {
									this.formMsg.passwordMsg = "";
									if (this.form.checkPassword == "") {
										this.formMsg.checkPasswordMsg = "请再次输入密码";
									} else {
										if (this.form.checkPassword !== this.form.password) {
											this.formMsg.checkPasswordMsg = "两次输入密码不一致";
										} else {
											//console.log("验证成功",this)
											this.formMsg.checkPasswordMsg = "";
											
											if (localStorage.getItem("loginDetail") =="wx") {
												this.bindUrl = "wxBind";
												localStorage.setItem('bindType','')
											} 
											else if (localStorage.getItem("loginDetail") == "qq") {
												this.bindUrl = "qqBind";
												localStorage.setItem('bindType','')
											}	
											var  that = this
										
											//console.log(this.bindUrl)
											if(this.bindUrl == 'wxBind'){
															this.$api.wxBind( 
											{
												mobile: that.form.phone,
												password: that.form.password,
												code: that.form.codes,
												unionid:localStorage.getItem('unionid'),
												access_token:localStorage.getItem('access_token'),
												openid:localStorage.getItem('openid')
											}
											).then((res) => {
													//console.log(res)
												if (res.code == 200) {
													//console.log(res)
													localStorage.setItem('UserToken', res.data.token)
													localStorage.setItem('userInfo', res.stringify(res.data.userInfo))
													localStorage.setItem('userId', res.data.user_id)
													this.$router.go(0)
												} else if (res.code == 0) {
													this.formMsg.phoneMsg = res.msg;
												} else if (res.code == 100010) {
													this.formMsg.codeMsg = res.msg;
												}
											});
										  	}
												else if(this.bindUrl == 'qqBind'){
													    this.$api.qqBind({
												mobile: that.form.phone,
												password: that.form.password,
												code: that.form.codes,
												access_token:localStorage.getItem('access_token'),
												appid:localStorage.getItem('appid'),
												openid:localStorage.getItem('openid')			
														}
															).then((res)=>{
													   	if (res.code == 200) {
													localStorage.setItem('UserToken', res.data.token)
													localStorage.setItem('userInfo',JSON.stringify(res.data.userInfo))
													localStorage.setItem('userId', res.data.user_id)
													this.$router.go(0)
												} else if (res.code == 0) {
													this.formMsg.phoneMsg = res.msg;
												} else if (res.code == 100010) {
													this.formMsg.codeMsg = res.msg;
												}
															})


												}
										
										}
									}
								}
							}
						}
					}
				}
			},
			//验证手机号
			checkMobile(str) {
				let re = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
				if (re.test(str)) {
					return true;
				} else {
					return false;
				}
			},
			// 验证密码
			checkPass(str) {
				let re = /^[0-9a-zA-Z]+$/;
				if (re.test(str)) {
					return true;
				} else {
					return false;
				}
			},
			//扫码
	  async		getWxScan() {
			
						 
		    const url  = await this.$api.wxGetUrl()
				console.log(url)
				this.wxbinds = url.data
				// window.open(url.data)
				window.location.href=`${url.data}`; 
				// localStorage.setItem("bindType", "wx");
				// var state = encodeURIComponent(
				// 	// "https://api.sz517.com/tk/wxLoginCallback"
				// 	undefined
				// );
				// var obj = new WxLogin({
				// 	self_redirect: 'false',

				// 	id: "wxImg",

				// 	appid: "wx927dd6abca2f3987",

				// 	scope: "snsapi_login",

				// 	redirect_uri: "https://www.sz517.com/Request/wxCallBack",

				// 	state: 980614,

				// 	style: "black",

				// 	href: "data:text/css;base64,LmltcG93ZXJCb3ggLm5vcm1hbFBhbmVse21hcmdpbi10b3A6IDE1cHg7fQouaW1wb3dlckJveCAucXJjb2RlIHt3aWR0aDogMjMwcHg7Ym9yZGVyLWNvbG9yOiNDNUUxRkY7fQouaW1wb3dlckJveCAudGl0bGUge2Rpc3BsYXk6IG5vbmU7fQ==",
				// });
		
				//console.log("路由")
				// let Wechat_return_code = window.location.href;
				//console.log(Wechat_return_code)
				//console.log(this.$refs.wxlogin)
			  // let lonode= document.getElementsByTagName('iframe')
				// lonode[0].setAttribute('sandbox',"allow-scripts  allow-top-navigation")
		   	//console.log(document.getElementsByTagName('iframe'))

			},
			// qq登录
		 async 	useqqlogin() {
			  localStorage.setItem('bindType','qq')
				const  data  = await 	this.$api.qqGetUrl()
				console.log(data)
				window.open(data.data, "_self");
			},
		timer1(){   //验证码60s内不能继续点击的函数
            if(this.time > 0) {
                this.time--;
                this.btnText = this.time + "s后重新获取"
                this.timer = setTimeout(this.timer1,1000)
            }else{
                this.time = 0;
                this.btnText = "获取验证码";
                this.clicks = false;
                clearTimeout(this.timer);
            }
        }, 
				
		close(){
			//console.log("res")
		     this.$emit("show",false)
		},	

			// 获取验证码
		async	getCode(index) {
				let par ={
					mobile:this.form.phone,
					status:index
				}		
					if(par.mobile !=='' && par.mobile.length ==11 ){
						const res  =  await  this.$api.getMobileCode(par)
						//console.log(res)
					if(res.data.msg === '该电话号码没有注册...'){
							this.$message.error(res.data.msg)
					}

					else if(res.data.msg === '触发分钟级流控Permits:'){
							this.$message.error("短信已发送请等待")
					}
					else{
							this.$message.success("发送成功")
							//console.log(res)
								
			this.clicks = true;  //禁用按钮，防止多次触发
      this.time = 60;  //60秒后能继续按按钮
      this.timer1();
					}
				}
				else{
							this.$message.error("电话格式错误")
				}
				// if (this.form.phone == "") {
				// 	this.formMsg.phoneMsg = "请输入手机号码";
				// } else {
				// 	if (!this.checkMobile(this.form.phone)) {
				// 		this.formMsg.phoneMsg = "请输入正确的手机号码";
				// 	} else {
				// 		this.formMsg.phoneMsg = "";
				// 		var i = 31;
				// 		var that = this;
				// 		if ((that.codeText = "获取验证码")) {
				// 			var param = {
				// 				mobile: this.form.phone,
				// 				type: index,
				// 				type_saction: index,
				// 			};
				// 			this.$get("capt", param).then((res) => {
				// 				if (res.code == 101) {
				// 					this.formMsg.phoneMsg = res.msg;
				// 				} else {
				// 					this.$message({
				// 						showClose: true,
				// 						message: "验证码发送成功！",
				// 						type: "success",
				// 					});
				// 					var timer = setInterval(() => {
				// 						i--;
				// 						that.codeText = i + "秒后重试";
				// 						if (i < 0) {
				// 							clearInterval(timer);
				// 							that.codeText = "获取验证码";
				// 							i = 31;
				// 						}
				// 					}, 1000);
				// 				}
				// 			});
				// 		} else {}
				// 	}
				// }
			},
			// 绑定回车事件
			keyupEnter() {
				var that = this;
				document.onkeydown = function(e) {
					let key = window.event.keyCode;
					if (key == 13) {
						if (that.showType == "login") {
							that.loginSub();
						} else if (that.showType == "regis") {
							that.regisSub();
						} else if (that.showType == "pass") {
							that.passSub();
						} else if (that.showType == "bind") {
							that.bindSub();
						}
					}
				};
			},
			//重置
			resetForm() {
				this.form = {
					phone: "",
					password: "",
					checkPassword: "",
					code: "",
				};
				this.resetMsg();
			},
			resetMsg() {
				this.formMsg = {
					phoneMsg: "",
					passwordMsg: "",
					checkPasswordMsg: "",
					codeMsg: "",
				};
			},
			//第三方登录获取用户信息
			getLoginInfo() {
				this.$post("UserInfos").then((res) => {
					localStorage.setItem("user_name", res.data.nickname);
					localStorage.setItem("user_image", res.data.image);
					localStorage.setItem("user_vip", res.data.is_vip);
				});
			},
			// 缓存个人信息
			storageUserInfo(id, name, img, vip) {
				localStorage.setItem("user_id", id);
				localStorage.setItem("token", id);
				localStorage.setItem("user_name", name);
				localStorage.setItem("user_image", img);
				localStorage.setItem("user_vip", vip);
			},
			// 成功提示
			succeMessage(msg) {
				var that = this;
				this.$message({
					message: msg,
					type: "success",
					showClose: true,
					onClose() {
						that.$router.push("/");
						that.$router.go(0);
					},
				});
				setTimeout(() => {
					that.$router.push("/");
					that.$router.go(0);
				}, 3000);
			},
		},
		components: {
			Code,
		},
		created() {
			
			var frames =	document.getElementsByTagName("iframe");

			// var frames = window.frames['iframe'];
			// frames.height = '200px'
			


		
			// 添加微信扫码js
			this.refreshCode()
			this.$addScript(
				"https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js",
				1
			);
			// 绑定回车事件
			this.keyupEnter();
		},
		watch: {
			form: {
				handler(newValue, oldValue) {
					this.resetMsg();
				},
				deep: true,
			},
		},
		mounted() {
			this.flag = !this.flag;
		},
	};
</script>

<style>
	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none !important;
		margin: 0;
	}

	.el-dialog__body {
		padding: 0 !important;
	}

	.el-dialog__header {
		display: none;
	}

	.box h3 {
		font-size: 20px;
		height: 60px;
		line-height: 60px;
		border-bottom: 1px solid #ebebeb;
		text-align: center;
	}

	.el-form {
		padding: 30px;
	}

	.box .el-form-item {
		margin-bottom: 30px;
		position: relative;
	}

	.login-err {
		position: absolute;
		top: 100%;
		color: #f56c6c;
		font-size: 12px;
		transition: all 0.4s ease 0s;
		height: 0;
		line-height: 24px;
		overflow: hidden;
	}

	.login-err-active {
		height: 24px;
	}

	.btn-login {
		width: 100%;
	}

	.login-code .el-input {
		width: 220px;
	}

	.login-code .el-button {
		width: 100px;
		height: 40px;
		float: right;
		padding: 0;
	}

	.login-code img {
		width: 100%;
		height: 100%;
	}

	.login-code a {
		position: absolute;
		right: 0;
		bottom: -35px;
	}

	.login-code a:hover {
		color: #e60012;
	}

	.box p {
		margin: 20px auto auto auto;
	}

	.box p img {
		position: relative;
		top: -2px;
	}

	.box p a:hover {
		color: #e60012;
	}

	.box .regis_a {
		float: right;
		color: #28d379;
		cursor: pointer;
	}

	.box .regis_a:hover {
		text-decoration: underline;
		color: #28d379;
	}

	.box .login_a {
		position: absolute;
		right: 264px;
		
		top: 359px;
		cursor: pointer;
	}
	.login_c{
				position: absolute;
	    right: 272px;
    top: 427px;
		cursor: pointer;
	}

	.login .login-code .el-button {
		background: none;
		color: none;
		padding: 0;
		border: none;
	}

	.regis .login-code .el-button,
	.login-wx .login-code .el-button,
	.login-pass .login-code .el-button,
	.login-bind .login-code .el-button {
		border: 1px solid#e60012;
		border-radius: 4px;
		color: #e60012;
	}

	.el-icon-close{
		position: absolute;
		top: 7px;
		left: 365px;
		font-size: 25px;
		 transform: all 3s;
	}	
	.el-icon-close:hover{
		 font-size: 30px;
		 cursor: pointer;
	}

	.el-button.is-disabled,
	.el-button.is-disabled:hover,
	.el-button.is-disabled:focus {
		color: #c0c4cc !important;
		border-color: #ebeef5 !important;
	}
	
	.login-wx dl {
	
	text-align: center;
		padding-bottom: 20px;
		height: 400px;
		padding-top: 16px;
	}

	.login-wx dt {
		/* margin: 20px 0 30px 0; */
	}

	.login-wx dt img {
		width: 150px;
		height: 150px;
		padding: 10px;
		border: 1px solid #ebebeb;
	}

	.login-wx dd {
		font-size: 16px;
		color: #666;
	}

	.login-wx p {
		color: #e60012;
		margin: 140px 0 0 0;
		cursor: pointer;
	}

	.login-wx p:hover {
		text-decoration: underline;
	}

	.login-wx .regis_a {
		float: none;
	}

	.login-wx p img {
		-webkit-animation: spin 2s linear infinite;
		animation: spin 2s linear infinite;
		margin-right: 5px;
	}

	@-webkit-keyframes spin {
		0% {
			-webkit-transform: rotate(0deg);
			-ms-transform: rotate(0deg);
			transform: rotate(0deg);
		}

		100% {
			-webkit-transform: rotate(360deg);
			-ms-transform: rotate(360deg);
			transform: rotate(360deg);
		}
	}

	@keyframes spin {
		0% {
			-webkit-transform: rotate(0deg);
			-ms-transform: rotate(0deg);
			transform: rotate(0deg);
		}

		100% {
			-webkit-transform: rotate(360deg);
			-ms-transform: rotate(360deg);
			transform: rotate(360deg);
		}
	}

	.box .btn-active {
		border-color: #ccc !important;
		background: #ccc !important;
		color: #fff !important;
	}

	.login,
	.regis,
	.login-wx,
	.login-bind,
	.login-pass,
	.login-frame {
		display: none;
	}

	#wxImg iframe {
		height: 320px;
	}
	#iframe{
		height: 550px !important;
		color: white !important; 
		 overflow: hidden;
            text-overflow: ellipse;
            white-space: nowrap;
	}
	#iframe  title {
			
	}
	.impowerBox .title{
		color: rgb(201, 45, 45) !important;
	}

	.wxsaom , .shuxin{
		text-align: center !important;
		display: inline-block;
		width: 100%;
		background-color: #fff;
	}

</style>
